<app-grid>
  <app-info-area>
      <p>The Queue Status page provides real-time insight into the routing queues between Lacuna Space and The Things Network (TTN).<br><br>
      When your device transmits a LoRaWAN message via Lacuna’s satellites, it is temporarily stored in a regional queue before being forwarded to the corresponding TTN routing point (APAC, EU, or NAM).<br><br>
      This view helps you monitor the health of these connections and verify that no packets are being delayed in the transmission process.</p>
  </app-info-area>
  <app-content-area>
      <h3 class="pt-6 pb-4 text-primary text-xl font-bold dark:text-white">Routing Queue Status</h3>
      <table class="w-full border-separate border-spacing-x-0 border-spacing-y-1">
        <thead>
        <tr>
          <th class="text-[10px] p-2 font-normal text-left">Region</th>
          <th class="text-[10px] font-normal text-left">Status</th>
          <th class="text-[10px] font-normal text-left">Queue</th>
          <th class="text-[10px] font-normal text-left">Last update</th>
        </tr>
        </thead>
        <tbody>
          @for (connector of connectorsWithStatus; track connector){
            <tr class="bg-white dark:bg-black dark:text-white">
              <td class="dark:border-[#171717] text-xs p-2 font-bold border border-gray-300 border-r-0 rounded-l-sm">{{connector.display_name}}</td>
              <td class="dark:border-[#171717] text-xs p-2 font-bold border border-gray-300 border-x-0">
                <span class="flex items-cente ">
                  <span class="relative inline-flex size-3 rounded-full mr-1" [ngClass]="getStatusClass(connector.status)"></span>
                  {{getStatusMessage(connector.status)}}
                </span>
                </td>
              <td class="dark:border-[#171717] text-xs p-2 font-bold border border-gray-300 border-x-0">{{ getQueueMessage(connector.status) }}</td>
              <td class="dark:border-[#171717] text-xs p-2 font-bold border border-gray-300 border-l-0 rounded-r-sm">{{ getTimeAgo(connector.minutesSinceUpdate) }}</td>
            </tr>
          }
        </tbody>
      </table>
  </app-content-area>
</app-grid>
